/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListRiskPolicyBypassRequestsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskPolicyBypassRequestsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskPolicyBypassRequestsSecurity = {
  option1?: ListRiskPolicyBypassRequestsSecurityOption1 | undefined;
  option2?: ListRiskPolicyBypassRequestsSecurityOption2 | undefined;
};

/**
 * Optional request status filter.
 */
export const QueryParamStatus = {
  Requested: "requested",
  Approved: "approved",
  Denied: "denied",
  Revoked: "revoked",
} as const;
/**
 * Optional request status filter.
 */
export type QueryParamStatus = ClosedEnum<typeof QueryParamStatus>;

export type ListRiskPolicyBypassRequestsRequest = {
  /**
   * Optional risk policy ID filter.
   */
  policyId?: string | undefined;
  /**
   * Optional request status filter.
   */
  status?: QueryParamStatus | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskPolicyBypassRequestsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskPolicyBypassRequestsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRiskPolicyBypassRequestsSecurityOption1$Outbound,
    ListRiskPolicyBypassRequestsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRiskPolicyBypassRequestsSecurityOption1ToJSON(
  listRiskPolicyBypassRequestsSecurityOption1:
    ListRiskPolicyBypassRequestsSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskPolicyBypassRequestsSecurityOption1$outboundSchema.parse(
      listRiskPolicyBypassRequestsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskPolicyBypassRequestsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskPolicyBypassRequestsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRiskPolicyBypassRequestsSecurityOption2$Outbound,
    ListRiskPolicyBypassRequestsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRiskPolicyBypassRequestsSecurityOption2ToJSON(
  listRiskPolicyBypassRequestsSecurityOption2:
    ListRiskPolicyBypassRequestsSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskPolicyBypassRequestsSecurityOption2$outboundSchema.parse(
      listRiskPolicyBypassRequestsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskPolicyBypassRequestsSecurity$Outbound = {
  Option1?: ListRiskPolicyBypassRequestsSecurityOption1$Outbound | undefined;
  Option2?: ListRiskPolicyBypassRequestsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskPolicyBypassRequestsSecurity$outboundSchema: z.ZodMiniType<
  ListRiskPolicyBypassRequestsSecurity$Outbound,
  ListRiskPolicyBypassRequestsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskPolicyBypassRequestsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskPolicyBypassRequestsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskPolicyBypassRequestsSecurityToJSON(
  listRiskPolicyBypassRequestsSecurity: ListRiskPolicyBypassRequestsSecurity,
): string {
  return JSON.stringify(
    ListRiskPolicyBypassRequestsSecurity$outboundSchema.parse(
      listRiskPolicyBypassRequestsSecurity,
    ),
  );
}

/** @internal */
export const QueryParamStatus$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamStatus
> = z.enum(QueryParamStatus);

/** @internal */
export type ListRiskPolicyBypassRequestsRequest$Outbound = {
  policy_id?: string | undefined;
  status?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskPolicyBypassRequestsRequest$outboundSchema: z.ZodMiniType<
  ListRiskPolicyBypassRequestsRequest$Outbound,
  ListRiskPolicyBypassRequestsRequest
> = z.pipe(
  z.object({
    policyId: z.optional(z.string()),
    status: z.optional(QueryParamStatus$outboundSchema),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyId: "policy_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskPolicyBypassRequestsRequestToJSON(
  listRiskPolicyBypassRequestsRequest: ListRiskPolicyBypassRequestsRequest,
): string {
  return JSON.stringify(
    ListRiskPolicyBypassRequestsRequest$outboundSchema.parse(
      listRiskPolicyBypassRequestsRequest,
    ),
  );
}
